/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { FC, useEffect, Dispatch, SetStateAction } from 'react'
import { FormikErrors, FormikTouched } from 'formik'

import { InputLabel, InputError } from '../../../components/Typography'
import { useDispatch } from '../../../store'
import { StyledInput, SelectGrid, SelectButton } from '../styled'

import { EmailForSignInKey } from 'src/constants/localStorageKeys'

type ProfileSetProps = {
  errors: FormikErrors<{
    birthday: string
  }>
  touched: FormikTouched<{
    birthday: string
  }>
  onBlur: (eventOrString: any) => void | ((e: any) => void)
  setGender: Dispatch<SetStateAction<{ id: number; name: string } | undefined>>
  selectedGender: { id: number; name: string } | undefined
  onChange: (
    eventOrPath: string | React.ChangeEvent<any>
  ) => void | ((eventOrTextValue: string | React.ChangeEvent<any>) => void)
  value: string
}

const ProfileSet: FC<ProfileSetProps> = ({
  setGender,
  selectedGender,
  onChange,
  value,
  errors,
  touched,
  onBlur,
}) => {
  const dispatch = useDispatch()

  useEffect(() => {
    const emailToProfile = window.localStorage.getItem(EmailForSignInKey)
    emailToProfile && dispatch.user.updateUser({ email: emailToProfile })
    window.localStorage.removeItem(EmailForSignInKey)
  }, [dispatch])

  return (
    <>
      <InputLabel htmlFor="gender">Gender</InputLabel>
      <SelectGrid>
        <SelectButton
          onClick={() => setGender({ id: 1, name: 'Male' })}
          isActive={selectedGender?.id === 1}
        >
          Male
        </SelectButton>
        <SelectButton
          onClick={() => setGender({ id: 2, name: 'Female' })}
          isActive={selectedGender?.id === 2}
        >
          Female
        </SelectButton>
        <SelectButton
          onClick={() => setGender({ id: 3, name: 'Non-binary' })}
          isActive={selectedGender?.id === 3}
        >
          Non-binary
        </SelectButton>
        <SelectButton
          onClick={() => setGender({ id: 4, name: 'MTF' })}
          isActive={selectedGender?.id === 4}
        >
          MTF
        </SelectButton>
        <SelectButton
          onClick={() => setGender({ id: 5, name: 'FTM' })}
          isActive={selectedGender?.id === 5}
        >
          FTM
        </SelectButton>
        <SelectButton
          onClick={() => setGender({ id: 6, name: 'Other' })}
          isActive={selectedGender?.id === 6}
        >
          Other
        </SelectButton>
      </SelectGrid>
      <InputLabel htmlFor="birthday">Birthday</InputLabel>
      <StyledInput
        id="birthday"
        name="birthday"
        type="date"
        placeholder="16.01.1980"
        onChange={onChange}
        onBlur={onBlur}
        value={value}
        isError={errors.birthday && touched.birthday ? true : false}
      />
      {errors.birthday && touched.birthday && (
        <InputError>{errors.birthday}</InputError>
      )}
    </>
  )
}

export default ProfileSet
